<template>
  <div class="modalStyle">
    <a-row type="flex" justify="space-between" class="formula">
      <h3 class="title">{{formula.formulaName}}</h3>
      <a-button @click="setState({formula:{}})" type="link" class="close-button" icon="close" />
    </a-row>
    <a-tabs :tabBarGutter="0" size="small" @change="tabsChange" :activeKey="tabSelect" :animated="false">
        <a-tab-pane key="1" tab="配方原料" style="padding:10px">
          <formula-raw ref="raw" />
        </a-tab-pane>
        <a-tab-pane key="2" tab="营养需要量" style="padding:10px">
          <formula-nutrition ref="nutrition" />
        </a-tab-pane>
        <a-select slot="tabBarExtraContent" v-if="tabSelect == 1" placeholder="所有原料" style="width:150px" v-model="rawCurrentType" >
          <a-select-option :key="index" :value="index" v-for="(item,index) in rawTypes">{{item}}</a-select-option>
        </a-select>
        <a-select slot="tabBarExtraContent" v-if="tabSelect == 2" placeholder="所有原料" style="width:150px" v-model="nutritionCurrentType" >
          <a-select-option :key="index" :value="index" v-for="(item,index) in ['显示所有指标','仅展示有值的指标','仅展示有约束的指标']">{{item}}</a-select-option>
        </a-select>
      </a-tabs>
  </div>
</template>

<script>
import { formulaMixins } from '../unitls'
import FormulaNutrition from './FormulaNutrition.vue'
import FormulaRaw from './FormulaRaw.vue'

export default {
  mixins:[formulaMixins],
  components:{FormulaNutrition, FormulaRaw},
  watch:{
    nutritionCurrentType(val){
      window.localStorage.setItem('nutritionCurrentType',val)
      if(this.$refs['nutrition']) this.$refs['nutrition'].filterNutrition(val)
    },
    rawCurrentType(val){
      window.localStorage.setItem('rawCurrentType',val)
      if(this.$refs['raw']) this.$refs['raw'].filterRaw(val)
    },
    formula(item){
      if(item.id){
        this.tabSelect = '1'
        this.rawCurrentType = 0
        this.nutritionCurrentType = 0
      }
    },
    resRaw(val){
      if(val) {
        this.rawCurrentType = 0
        this.nutritionCurrentType = 0
      }
    },
    resNut(val){
      if(val) {
        this.rawCurrentType = 0
        this.nutritionCurrentType = 0
      }
    },
 
  },
  mounted(){
    let rawCurrentType = window.localStorage.getItem('rawCurrentType')
    let nutritionCurrentType = window.localStorage.getItem('nutritionCurrentType')
    if(!rawCurrentType){
      rawCurrentType = 0
    }
    this.rawCurrentType = Number(rawCurrentType)
    if(!nutritionCurrentType){
      nutritionCurrentType = 0
    }
    this.nutritionCurrentType = Number(nutritionCurrentType)
  },
  data(){
    return{
      nutritionCurrentType: 0,
      rawCurrentType: null,
      tabSelect:'1'
    }
  },
  methods:{
    tabsChange(val){
      this.tabSelect = val
    }
  }
}
</script>

<style lang="scss" scoped>

  .formula{
    padding:15px 10px 12px;
  }
  .title{
    margin:0;
    padding:0;
  }
  .modalStyle{
    // padding:10px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #fff;
    z-index: 2;
  }
</style>
